'use client';

import { SessionProvider } from 'next-auth/react';

import MergeDraftOnLogin from '../components/MergeDraftOnLogin';

/**
 * NextAuth Session Provider
 * Wraps the app with NextAuth session management
 *
 * @deprecated The old localStorage-based AuthContext is replaced by NextAuth
 * Use the useAuth hook from hooks/useAuth.js instead
 */
export const AuthProvider = ({ children }) => {
  // iOS 20+ safe: Disable refetchInterval to prevent hydration mismatch
  return (
    <SessionProvider refetchInterval={0} refetchOnWindowFocus={false} refetchWhenOffline={false}>
      <MergeDraftOnLogin />
      {children}
    </SessionProvider>
  );
};

// Re-export the modern useAuth hook for backward compatibility
export { useAuth } from '../hooks/useAuth';
